import { DenyExternalFlightBookingRequestForAdminState } from './denyExternalFlightBookingRequestForAdmin.types'

const initialState: DenyExternalFlightBookingRequestForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
